import Axios from 'axios'

const http = Axios.create({});
export default http
